<div id="map-open"></div>
<!-- Single button -->
<div class="content-map-option-btn btn-group dropup" [ngClass]="{'lower-bottom': !showMultipleOnMap}">
  <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Change Map">
    <i class="fa fa-cogs"></i>
  </button>
  <ul class="dropdown-menu">
    <li><a class="clickable" (click)="mapProviderToggle()">Google Map</a></li>
  </ul>
</div>
<div class="content-toggle-poi-btn btn btn-primary" *ngIf="showMultipleOnMap" (click)="poiToggle()" [ngClass]="{disabled: !showPois}" title="POI">
	<i class="fa fa-map-marker"></i>
</div>
<div class="content-toggle-zone-btn btn btn-primary" *ngIf="showMultipleOnMap" (click)="zonesToggle()" [ngClass]="{disabled: !showZones}" title="Zones">
	<i class="fa fa-square-o"></i>
</div>
<div class="content-reset-btn btn btn-primary" *ngIf="showMultipleOnMap" (click)="resetZoom()" title="Reset Zoom">
	<i class="fa fa-globe"></i>
</div>
<div class="content-controls-btn btn btn-primary" (click)="toggleShowControl()" [ngClass]="{'controls-shown-map': showControls && showMultipleOnMap, 'controls-shown-trip': showControls && !showMultipleOnMap}">
	<i class="fa fa-caret-square-o-down" *ngIf="!showControls"></i>
	<i class="fa fa-caret-square-o-up" *ngIf="showControls"></i>
</div>